export const TIME_PERIODS = [
  {
    id: "morning",
    label: "Morning",
    icon: "fa-solid fa-sun",
    hours: [5, 12],
  },
  {
    id: "noon",
    label: "Noon",
    icon: "fa-solid fa-cloud-sun",
    hours: [12, 17],
  },
  {
    id: "evening",
    label: "Evening",
    icon: "fa-solid fa-cloud-moon",
    hours: [17, 21],
  },
  {
    id: "twilight",
    label: "Night",
    icon: "fa-solid fa-moon",
    hours: [21, 24],
  },
];

export const getSlotPeriod = (slot) => {
  const start = slot.split("-")[0]?.trim();
  const hour = parseInt(start?.split(":")[0], 10);
  if (Number.isNaN(hour)) return "morning";
  if (hour >= 21 || hour < 5) return "twilight";
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 17) return "noon";
  return "evening";
};

const to12hParts = (t) => {
  const [hStr, mStr] = (t || "").trim().split(":");
  let h = parseInt(hStr, 10);
  const m = parseInt(mStr, 10) || 0;
  if (Number.isNaN(h)) return { text: t, ampm: "" };
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  const text = m ? `${h}:${String(m).padStart(2, "0")}` : `${h}`;
  return { text, ampm };
};

export const formatSlotDisplay = (slot) => {
  const [startRaw, endRaw] = slot.split("-");
  const s = to12hParts(startRaw);
  const e = to12hParts(endRaw);
  if (!s.ampm || !e.ampm) return `${s.text} – ${e.text}`;
  return `${s.text} ${s.ampm} – ${e.text} ${e.ampm}`;
};

/** Start / end strings for slot list rows */
export const formatSlotParts = (slot) => {
  const [startRaw, endRaw] = slot.split("-");
  const s = to12hParts(startRaw);
  const e = to12hParts(endRaw);
  const fmt = ({ text, ampm }) => (ampm ? `${text} ${ampm}` : text);
  return { start: fmt(s), end: fmt(e) };
};

/** Compact label for booking dock slot buttons */
export const formatSlotShort = (slot) => {
  const [startRaw, endRaw] = slot.split("-");
  const s = to12hParts(startRaw);
  const e = to12hParts(endRaw);
  if (!s.ampm || !e.ampm) return `${s.text} – ${e.text}`;
  if (s.ampm === e.ampm) return `${s.text} – ${e.text} ${s.ampm}`;
  return `${s.text} ${s.ampm} – ${e.text} ${e.ampm}`;
};

export const groupSlotsByPeriod = (slots, isPastSlot) =>
  slots
    .map((slot, index) => ({ slot, index }))
    .filter(({ slot }) => !isPastSlot(slot))
    .reduce((acc, item) => {
      const period = getSlotPeriod(item.slot);
      if (!acc[period]) acc[period] = [];
      acc[period].push(item);
      return acc;
    }, {});
